import { Directive , ElementRef, HostListener} from '@angular/core';
 // 
/**
 * Generated class for the DirectivesIonicInputNumberDirective directive.
 *
 * See https://angular.io/api/core/Directive for more info on Angular
 * Directives.
 */
@Directive({
  selector: '[directives-ionic-input-number]' // Attribute selector
})
// @HostListener('keyup')
export class DirectivesIonicInputNumberDirective {


  constructor() {
    console.log('Hello DirectivesIonicInputNumberDirective Directive');

  }
  @HostListener( 'window:keydown', [ '$event' ] )
handleKeyboardEventkeydown(event: KeyboardEvent) { 
   
  if (event) {
    
      if((event.target as HTMLInputElement).name=="phone_number"){
        return this.isNumberKey(event);
      }
      if((event.target as HTMLInputElement).name=="stdcode"){
        return this.isNumberKey(event);
      }
      
      
     
  // 
  }
}
 
isNumberKey(event) {
  let charCode = event.which ? event.which : event.keyCode;
  if (charCode > 31 && (charCode < 48 || charCode > 57)) {
  return false;
  }
  return true;
  }
  
}



// WEBPACK FOOTER //
// ./src/directives/directives-ionic-input-number/directives-ionic-input-number.ts